export default {"src":"https://www.targetdefense.com/_next/static/media/check-mark.550c9377.svg","height":21,"width":25,"blurWidth":0,"blurHeight":0};